import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/hero';
import Card from '../components/card';
import CardContainer from '../components/cardcontainer';
import SectionHeading from '../components/sectionheading';
import Footer from '../components/footer';
import ShapesBackground from '../components/shapesbackground';
import { FaApple, FaGooglePlay } from "react-icons/fa";
import barcodeImg from "../assets/phone/barcode.png";

// Category images
import restaurantsImg from "../assets/categories/restaurant.png";
import fruitsImg from "../assets/categories/fruits.png";
import groceryImg from "../assets/categories/groceries.png";
import meatImg from "../assets/categories/meat.png";
import chickenImg from "../assets/categories/chicken.png";
import fishImg from "../assets/categories/fish.png";
import nutsImg from "../assets/categories/nuts.png";
import coffeeImg from "../assets/categories/coffee.png";
import bakeryImg from "../assets/categories/bakery.png";
import cafeImg from "../assets/categories/cafe.png";
import pharmaciesImg from "../assets/categories/pharmacies.png";
import clothesImg from "../assets/categories/clothes.png";
import perfumesImg from "../assets/categories/perfumes.png";
import cosmeticImg from "../assets/categories/cosmetic.png";
import laundryImg from "../assets/categories/laundary.png";
import hotelImg from "../assets/categories/hotel.png";
import rentcarsImg from "../assets/categories/rentcars.png";
import taxiImg from "../assets/categories/taxi.png";

// Vendor logos
import pizzaloverLogo from "../assets/vendors/pizzalover.png";
import rosesLogo from "../assets/vendors/roses.png";
import chubzzLogo from "../assets/vendors/chubzz.png";
import jalalLogo from "../assets/vendors/jalal.png";

// Why Choose Selal Icons
import varietyIcon from '../assets/icons/variety.png';
import paymentIcon from '../assets/icons/payment.png';
import fastIcon from '../assets/icons/fast.png';

import { useLang } from '../context/langcontext';
import '../styles/style.css';

const Home = () => {
  const { t, lang } = useLang();

  const categories = [
    { key: "restaurants", img: restaurantsImg },
    { key: "fruitsVeg", img: fruitsImg },
    { key: "grocery", img: groceryImg },
    { key: "meat", img: meatImg },
    { key: "chicken", img: chickenImg },
    { key: "fishSeafood", img: fishImg },
    { key: "nuts", img: nutsImg },
    { key: "spicesCoffee", img: coffeeImg },
    { key: "bakery", img: bakeryImg },
    { key: "cafe", img: cafeImg },
    { key: "pharmacies", img: pharmaciesImg },
    { key: "clothes", img: clothesImg },
    { key: "perfumes", img: perfumesImg },
    { key: "cosmetics", img: cosmeticImg },
    { key: "laundry", img: laundryImg },
    { key: "hotelReservations", img: hotelImg },
    { key: "rentCars", img: rentcarsImg },
    { key: "taxi", img: taxiImg },
  ];

  const homeVendors = [
    { id: 1, name: { en: "Pizza Lover", ar: "بيزا لوفر" }, logo: pizzaloverLogo },
    { id: 2, name: { en: "Roses", ar: "روزس" }, logo: rosesLogo },
    { id: 3, name: { en: "Chubbz", ar: "تشابز" }, logo: chubzzLogo },
    { id: 4, name: { en: "Jalal Efendi", ar: "جلال أفندي" }, logo: jalalLogo },
  ];

  const carouselRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isManualScrolling, setIsManualScrolling] = useState(false);
  const scrollSpeed = 1.1;

  // Triple the categories for smoother infinite scroll
  const infiniteCategories = [...categories, ...categories, ...categories];

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel || isPaused || isManualScrolling) return;

    let animationId;
    
    const smoothScroll = () => {
      const cardWidth = carousel.firstElementChild?.offsetWidth || 250;
      const gap = 20;
      const scrollAmount = cardWidth + gap;
      const isRTL = lang === 'ar';
      
      if (isRTL) {
        // RTL: decrease scrollLeft (moves visually to the right)
        // When we reach the far left (scrollLeft becomes very negative), reset to 0
        if (carousel.scrollLeft <= -scrollAmount * categories.length) {
          carousel.scrollLeft = 0;
        } else {
          carousel.scrollLeft -= scrollSpeed;
        }
      } else {
        // LTR: increase scrollLeft (moves visually to the left)
        // When we reach the far right, reset to 0
        if (carousel.scrollLeft >= scrollAmount * categories.length) {
          carousel.scrollLeft = 0;
        } else {
          carousel.scrollLeft += scrollSpeed;
        }
      }
      
      if (!isPaused && !isManualScrolling) {
        animationId = requestAnimationFrame(smoothScroll);
      }
    };

    animationId = requestAnimationFrame(smoothScroll);

    return () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };
  }, [isPaused, isManualScrolling, categories.length, lang]);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  const handleManualScroll = (direction) => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    setIsManualScrolling(true);
    setIsPaused(true);

    const cardWidth = carousel.firstElementChild?.offsetWidth || 250;
    const gap = 20;
    
    // Simple and direct: left = scroll left, right = scroll right (no RTL reversal needed)
    const scrollAmount = (cardWidth + gap) * (direction === 'left' ? -1 : 1);
    
    carousel.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });

    if (window.scrollTimeout) {
      clearTimeout(window.scrollTimeout);
    }

    window.scrollTimeout = setTimeout(() => {
      setIsManualScrolling(false);
      setIsPaused(false);
      window.scrollTimeout = null;
    }, 2000);
  };

  const handleUserInteraction = () => {
    setIsManualScrolling(true);
    setIsPaused(true);
    
    if (window.scrollTimeout) {
      clearTimeout(window.scrollTimeout);
    }
    
    window.scrollTimeout = setTimeout(() => {
      setIsManualScrolling(false);
      setIsPaused(false);
      window.scrollTimeout = null;
    }, 2000);
  };

  return (
    <>
      <ShapesBackground />

      {/* Hero */}
<Hero
  heroImage={require('../assets/phone/phone-hero.png')}
  showLogo={false}       // hide logo only on home
  showHeading={false}    // hide heading only on home
  customSubtext={t("heroSubtext")}
  customDescription={t("heroDescription")}
/>


      {/* Add geometric elements for hero */}
      <div className="hero-geometric-elements">
        <div className="geometric-element circle-1"></div>
        <div className="geometric-element circle-2"></div>
        <div className="geometric-element triangle-1"></div>
        <div className="geometric-element triangle-2"></div>
        <div className="geometric-element hexagon"></div>
        <div className="dots-pattern"></div>
      </div>

      {/* Save More with Selal Plus */}
      <section className="selal-plus" id="selal-plus">
        <SectionHeading text={t("selalPlusTitle") || "Save More with Selal Plus"} />
        <div className="selal-plus-container">
          <h2 className="selal-plus-heading">{t("selalPlusHeading") || "Subscribe to Selal Plus and enjoy:"}</h2>
          <div className="selal-plus-cards">
            <div className="selal-plus-card">
              <h3>{t("unlimitedDeliveryTitle") || "Unlimited Free Delivery"}</h3>
              <p>{t("unlimitedDeliveryDesc") || "Never pay delivery fees again on any order, any time of day."}</p>
            </div>
            <div className="selal-plus-card">
              <h3>{t("exclusiveDiscountsTitle") || "Exclusive Member Discounts"}</h3>
              <p>{t("exclusiveDiscountsDesc") || "Get special discounts and deals available only to Selal Plus members."}</p>
            </div>
            <div className="selal-plus-card">
              <h3>{t("prioritySupportTitle") || "Priority Customer Support"}</h3>
              <p>{t("prioritySupportDesc") || "Get faster support and priority handling for all your orders and inquiries."}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Explore Categories Carousel */}
      <section className="categories" id="categories">
        <SectionHeading text={t("exploreCategoriesTitle") || "Explore Categories"} />
        <div className="carousel-wrapper">
          <button 
            className="carousel-arrow left" 
            onClick={() => handleManualScroll('left')} 
            aria-label="Scroll left"
          >
            ◀
          </button>

          <div
            className="categories-carousel"
            ref={carouselRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleUserInteraction}
            onWheel={handleUserInteraction}
            style={{
              display: 'flex',
              gap: '20px',
              overflowX: 'hidden',
              overflowY: 'visible',
              scrollBehavior: 'auto',
              paddingBottom: '30px',
              paddingTop: '20px',
              transform: 'translateZ(0)',
              willChange: 'scroll-position'
            }}
          >
            {infiniteCategories.map((cat, index) => {
              const categoryKey = "category" + cat.key;
              const categoryDescKey = "category" + cat.key + "Desc";
              
              return (
                <Card 
                  key={cat.key + "-" + index}
                  className="category-card"
                  style={{ 
                    minWidth: '250px',
                    flexShrink: 0
                  }}
                >
                  <div className="category-img-wrapper">
                    <img src={cat.img} alt={t(categoryKey)} className="category-img"/>
                  </div>
                  <h4 className="category-name">{t(categoryKey)}</h4>
                  <p className="category-desc">{t(categoryDescKey)}</p>
                  <a
                    href="https://apps.apple.com/om/app/selal/id6596748079"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="category-link"
                  >
                    {t("exploreInApp")}
                  </a>
                </Card>
              );
            })}
          </div>

          <button 
            className="carousel-arrow right" 
            onClick={() => handleManualScroll('right')} 
            aria-label="Scroll right"
          >
            ▶
          </button>
        </div>
      </section>

      {/* Our Vendors */}
      <section className="vendors" id="vendors">
        <SectionHeading text={t("ourVendorsTitle") || "Our Vendors"} />
        <div className="card-container-wrapper">
          <CardContainer ignoreMatchHeight={true}>
            {homeVendors.map((vendor) => (
              <Card key={vendor.id}>
                <img
                  src={vendor.logo}
                  alt={vendor.name[lang] || vendor.name.en}
                  style={{ width: "150px", height: "150px", objectFit: "contain", marginBottom: "1rem", borderRadius: "15px" }}
                />
                <span>{vendor.name[lang] || vendor.name.en}</span>
              </Card>
            ))}
          </CardContainer>
        </div>
        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <Link to="/vendors" className="btn">
            {t("exploreVendorsBtn") || "Explore Our Vendors"}
          </Link>
        </div>
      </section>

      {/* Why Choose Selal */}
      <section className="why-choose" id="why-choose">
        <SectionHeading text={t("whyChooseTitle") || "Why Choose Selal"} />
        <div className="card-container-wrapper">
          <CardContainer>
            <Card className="home-why-card">
              <img src={varietyIcon} alt="Wide Variety" className="home-card-icon" />
              <h3>{t("allInOneTitle")}</h3>
              <h4 className="home-card-subtitle">{t("allInOneSubtitle")}</h4>
              <p>{t("allInOneDesc")}</p>
            </Card>
            <Card className="home-why-card">
              <img src={paymentIcon} alt="Payment Methods" className="home-card-icon" />
              <h3>{t("yourWayTitle")}</h3>
              <h4 className="home-card-subtitle">{t("yourWaySubtitle")}</h4>
              <p>{t("yourWayDesc")}</p>
            </Card>
            <Card className="home-why-card">
              <img src={fastIcon} alt="Fast Delivery" className="home-card-icon" />
              <h3>{t("fastDeliveryTitle")}</h3>
              <h4 className="home-card-subtitle">{t("fastDeliverySubtitle")}</h4>
              <p>{t("fastDeliveryDesc")}</p>
            </Card>
          </CardContainer>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section" id="available-now">
        <div className="text-content">
          <h2>{t("availableNowTitle")}</h2>
          <p>{t("availableNowDesc1")}</p>
          <p>{t("availableNowDesc2")}</p>
          <p>{t("availableNowDesc3")}</p>
          <div className="btns">
            <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
              <FaApple /> {t("appStoreBtn")}
            </a>
            <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
              <FaGooglePlay /> {t("playStoreBtn")}
            </a>
          </div>
        </div>
        <div className="image-container">
          <img src={barcodeImg} alt={t("barcodeAlt")} />
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Home;